import { render, staticRenderFns } from "./TabelaDentistas.vue?vue&type=template&id=5118091a&"
import script from "./TabelaDentistas.vue?vue&type=script&lang=js&"
export * from "./TabelaDentistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports